<template>
  <div id="app_content" class="public">
    <full-page
        id="app-scroll"
        class="container-init"
        :options="optionsFullPage"
        ref="full_page">

      <div class="section std top d-flex is-justify-content-center is-align-items-center">
        <!--        <div class="main-logo">-->
        <!--          <img :src="url('/storage/media/vetrina/logo_home.svg')">-->
        <!--        </div>-->

        <div class="video-overlay"></div>

        <!-- <video :src="video_url" id="home-video"
          autoplay loop muted playsinline>
        </video> -->

        <video-background v-view="viewHandler"
                          :src="video_url"
                          style="height: 100vh;"
                          autoplay loop muted playsinline>

        </video-background>
        <a class="discover-button">
          <img
              @click="scrollDown"
              :src="url('/media/vetrina/discover_button.svg')"
              alt="discover btn"
          />
          <span class="discover-text">{{ trans.get('public.home.discover-more-btn') }}</span>
        </a>
        <popup-regione id="popup-regione"/>
      </div>


      <ns-prodotti/>
      <ns-prodotti-2/>
      <industrie/>
      <materials/>
      <materials-2/>
      <gallery/>

    </full-page>
    <!-- </vue-fullpage> -->
  </div>
</template>

<script>
//https://github.com/gs-shop/vue-slick-carousel/blob/master/docs/API.md#props

// import Login from './../login'
// import Login from './../form-contact'
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueFullPage from "vue-fullpage.js";
import popupRegione from "../popup-regione";
// Componente per il video responsive
import VideoBackground from 'vue-responsive-video-background-player';

export default {
  components: { /*Login ,*/ VueFullPage, "v-slick": VueSlickCarousel, VideoBackground, popupRegione},

  data: function () {

    return {
      opened_float_login: false,
      optionsFullPage: {
        licenseKey: "Ululab21-key00001-FullPage-ScrollPG",
        navigation: false,
        controlArrows: false,
        scrollBar: true,
        loopBottom: false,
        responsiveWidth: 3000,
        verticalCentered: false,
        fitToSection: true,

        //events
        onLeave: function (origin, destination, direction) {
          let fpNav = document.getElementById("fp-nav");
          if (fpNav) {
            if (destination.isFirst) {
              fpNav.classList.remove("active-prev");
              fpNav.classList.add("active-next");
            } else if (destination.isLast) {
              fpNav.classList.remove("active-next");
              fpNav.classList.add("active-prev");
            } else {
              fpNav.classList.add("active-prev");
              fpNav.classList.add("active-next");
            }
          }
        },
        afterRender: function () {
          let fpNav = document.getElementById("fp-nav");
          if (fpNav) {
            fpNav.classList.remove("active-prev");
            fpNav.classList.add("active-next");
          }
        },
      },

      postImages: [
        // dev
        // this.url('/media/image-page/home-gallery.png'),
        // this.url('/media/image-page/home-gallery-unsplash-1.jpg'),
        // this.url('/media/image-page/home-gallery.png'),
        // this.url('/media/image-page/home-gallery-unsplash-2.jpg'),
        // this.url('/media/image-page/home-gallery.png'),
        // this.url('/media/image-page/home-gallery-unsplash-2.jpg'),

        this.url("/media/image-page/home-gallery/foto-gallery1.jpg"),
        this.url("/media/image-page/home-gallery/foto-gallery2.jpg"),
        this.url("/media/image-page/home-gallery/foto-gallery3.jpg"),
        this.url("/media/image-page/home-gallery/foto-gallery4.jpg"),
        this.url("/media/image-page/home-gallery/foto-gallery5.jpg"),
      ],

      isMounted: false,
      slickOptions: {
        lockAnchors: true,

        focusOnSelect: false,
        rtl: false,
        draggable: false,
        slidesToShow: 3,
        centerMode: true, //
        swipeToSlide: false,
        touchMove: false,
        infinite: true,
        arrows: true,
        responsive: [
          {
            breakpoint: 500,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
        ],
      },

      macrofamily: {
        NAS: null,
        CIN: null,
      },

    }

  }, // data

  created: function () {
    // let vue = this;
    // setTimeout(function() {
    //   vue.isMounted = true;
    // }, 2000)
    this.isMounted = true;

  },

  mounted: function () {
    this.loadFamily();
    // this.startVideo();
    // this.setLockAnchors(true);
    $('video').attr('id', 'mainvideo')
    if (window.innerWidth < 576) {
      window.addEventListener('scroll', (event) => {
        let scroll = window.scrollY
        let popupRegione = document.getElementById('popup-regione')
        if (scroll > 217) {
          popupRegione.setAttribute('style', 'position: absolute; bottom: 0;')
        } else if (scroll < 217) {
          popupRegione.setAttribute('style', 'position: fixed;')
        }
      })
    }
  },

  computed: {

    video_url() {


      if (window.innerWidth > window.innerHeight){
        return this.url('/storage/media/videos/video_home.mp4');
      } else {
        return this.url('/storage/media/videos/video_home_mobile.mp4');
      }


    }

  },

  methods: {
    viewHandler(e) {

      const vid = document.getElementById('mainvideo')
      if (e.type === 'enter' || e.type === 'progress') {

        vid.play()
      }
    },
    scrollDown: function () {
      //window.scrollBy(0, 1000);
      document.querySelector('#ns-prodotti').scrollIntoView({
        behavior: 'smooth'
      })
    },
    loadFamily: function () {
      var vue = this;

      axios({
        method: "get",
        url: window.location.origin + "/data/get-family",
        params: {
          cod: Object.keys(vue.macrofamily),
          type: "macro",
        },
      })
          .then((res) => {
            if (res.data.family) vue.macrofamily = res.data.family;
          })
          .catch((err) => {
            vue.loading = false;
            console.log(err.response.data)
            vue.$store.commit("add_message", {
              type: "error",
              message: err.response.data.message,
            });
          });
    },

    lorem: function (p = 0) {
      let lorem =
          "Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";
      // let lastP = lorem.lastIndexOf('.');
      // return (p) ? lorem.slice(0, (p <= lastP) ? p : lastP ) : lorem;
      return lorem;
    },

    layoutText: function (v = 1) {
      switch (v) {
        case 1:
          return "Be conservatively in the selections of the countries and the languages’ in which your AdWords ads are supposed to appear. If your product or your service turn only to customers speaking in a German manner, you should tune “Germany” and “Austria” as countries. With corresponding success you can try out also further countries, for example Switzerland, and areas close to the border. This method can also be applied to any other language.";
          break;

        case 2:
        default:
          return "Be conservatively in the selections of the countries and the languages’ in which your AdWords ads are supposed to appear. If your product or your service turn only to customers speaking in a German manner, you should";
          break;
      }
    },

    startVideo() {

      $('#home-video').bgVideo({
        fadeIn: 0,
        showPausePlay: false
      })
      $('#home-video')[0].play();

    }

  }
};
</script>

<style lang="scss">
.public {
  background-color: #26262a;
}

#mainvideo {
  @media (max-width: 576px) {
    min-height: 100%;
    max-width: 100%;
    height: auto !important;
    width: 100% !important;
  }
}

//html {
//  scroll-behavior: smooth;
//}
.iframe-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.iframe-wrapper iframe,
.iframe-wrapper video
.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.video-overlay {
  z-index: 2;
  background-color: transparent;
}

/*
 * contenuto delle sezioni allineato togliendo l'ingombro
 * del menù
*/
.section.std.top {
  position: relative;
  padding: 0;
  //background-image: url("/storage/media/vetrina/banner_people.jpg");
  // background-size: cover;
  // background-position: bottom;
  // @media (max-width: 1200px) {
  //   background-image: url("/storage/media/vetrina/banner_verde.jpg");
  //
  // }
  .main-logo {
    display: none;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    @media (max-width: 1200px) {
      display: block;
    }
  }
}

.player {
  width: 100vw;
  height: 100vh;
}

.section .section-container {
  max-width: calc(100% - var(--public-menu-width));
  margin: 0 0 0 var(--public-menu-width);
  width: 100%;
}

.content {
  width: 100%;
  margin: auto;
}

.container {
  width: 100%;
}

.row {
  width: 100%;
}

.section {
  &.std.top {

    .section-container {
      position: relative;
      height: 100%;

    }

    .discover-button {
      position: absolute;
      bottom: 2%;
      left: 50%;
      transform: translate(-50%);
      @media (max-width: 576px) {
        bottom: 10%;
        img {
          transform: scale(0.7);
        }
      }

      .discover-text {
        color: var(--text-white);
        @media (max-width: 576px) {
          margin-top: -15px;
        }
      }
    }

    .jumbo-button-section {
      position: absolute;
      bottom: 20px;
      left: 50%;

      &:hover .discover-button .discover-text {
        color: var(--greenb2b)
      }
    }
  }
}

@media screen and (min-width: 2000px) {
  .section.std {
    .content {
      .container {
        max-width: 90vw;
      }
    }
  }
}

@media screen and (max-width: 1220px) {
  .section .section-container {
    max-width: 95%;
    margin: auto;
  }
}

/*
 * payoff
*/
.payoff {
  font-size: 60px;
  font-weight: lighter;
}

.vp-center {
  justify-content: flex-start !important;
}

@media screen and (max-width: 750px) {
  .payoff {
    font-size: 2.4em;
  }
}

@media screen and (max-width: 400px) {
  .payoff {
    font-size: 2em;
  }
}

.section.top,
.section.bgi {
  width: 100%;
  height: 100vh;
  color: white;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: cover;
  background-position: initial;
}

.section.bgi {
  background-size: contain;
}

.section-sub {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section.std {
  width: 100%;
  height: 100vh;
  background-color: var(--black-2);
}

.section.top .content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.section.top .content h1 {
  font-size: 60px;
  font-weight: lighter;
}

#app-scroll
> div.section.top.fp-section.active.fp-table.fp-completely
> div
> div
> div
> div
> img {
  width: 420px;
  height: 130px;
}

.section.top .fp-tableCell {
  // width: calc(100vw - 250px);
  height: calc(100vh - 70px) !important;
  float: right;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}

.section.top {
  height: 100vh !important;

  .section-container-center-mode {
    height: 100%;
    display: flex;
    align-items: center;
  }

  .discover-button {
    margin-top: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #d8d8d8;

    .discover-text {
      display: inline-block;
      margin-bottom: 20px;
      margin-top: 10px;
      color: #d8d8d8;
    }
  }
}

.section.std .content .text {
  color: white;
  width: 100%;
  max-width: 95%;
  width: 760px;
  margin: auto;
}

.section.std .content .text h1 {
  font-weight: 500;
}

.section.std .content .text p {
  margin: 0;
  font-weight: 300;
  color: var(--text-white);
}

.content-gallery {
  width: 100%;
  margin: auto;
  position: relative;
}

.content-gallery .slick-slider {
  margin-left: -180px;
}

.content-source-media {
  width: auto;
}

.content-source-media .source {
  width: inherit;
}

.content-source-media .source img {
  display: block;
  width: inherit;
  padding: 2em;
  transition: padding 0.2s 0.2s ease-in-out;
}

.slick-slide[aria-hidden="false"]:not(.slick-current) .source img {
  opacity: 0.4;
}

.slick-slide[aria-hidden="true"] .source img {
  opacity: 0.1;
}

.slick-slide.slick-current {
  z-index: 2;
  position: relative;
}

.slick-slide.slick-current .source img {
  padding: 0;
  opacity: 1;
}

.slick-prev::before,
.slick-next::before {
  content: "";
}

.btn-circle.arrow {
  display: flex;
  align-items: center;
  justify-content: center;
}

.btn-circle.slick-prev {
  top: 110px;
  left: 70%;
}

.btn-circle.slick-next {
  bottom: 40px;
  left: 70%;
}

.btn-circle.arrow span {
  width: 48px;
  height: 22px;
  display: inline-block;
  position: absolute;
  background-repeat: no-repeat;
  background-origin: initial;
  background-clip: initial;
  background-size: 100% auto;
  background-position: center;
}

.btn-circle.slick-prev span {
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}

/* ---------------------------- */

.fp-tableCell {
  position: relative;
}

.section:not(.gallery) .content,
.section-sub .content {
  max-width: 98%;
  max-width: 760px;
  margin: auto;
  position: relative;
}

.section .wrapper-data {
  width: 100%;
  margin-top: 20px;
}


@media (min-width: 1200px) {
  .section.top .fp-tableCell {
    width: calc(100vw - 250px);
  }
}

@media (max-width: 576px) {
  #home-video {
    min-width: 100vw;
    min-height: 100vh;
    max-width: unset;
  }
}

@media (min-width: 1921px) {
  .row {
    max-width: 100%;
  }
  .section {
    //height: unset !important;
  }
  .section.std.gallery {
    //height: unset !important;
  }
}
</style>
